import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about">
      <div className="about-hero">
        <div className="about-hero-background">
          <div className="about-hero-particles"></div>
          <div className="gradient-orb gradient-orb-1"></div>
          <div className="gradient-orb gradient-orb-2"></div>
          <div className="gradient-orb gradient-orb-3"></div>
        </div>
        <div className="container">
          <h1 className="about-title">About jagoalt</h1>
          <p className="about-subtitle">
            A web design and development studio focused on building products people love to use
          </p>
        </div>
      </div>

      <div className="about-content">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <h2>Designing and building digital products since 2018</h2>
              <p>
                jagoalt started with a simple passion for creating things on the web. What began 
                as small projects and experiments has grown into a studio that designs and builds 
                websites, web applications, and digital experiences for real businesses and users.
              </p>
              
              <p>
                We're currently focused on community platforms and web applications — including 
                Strandx, OpenAth, Petz4Days, and Help A Brotha — each in active development 
                and testing as we prepare for launch.
              </p>

              <h3>What we do</h3>
              <ul>
                <li>Design and build modern, responsive websites</li>
                <li>Develop full-featured web applications and SaaS platforms</li>
                <li>Create cross-platform mobile applications</li>
                <li>Build real-time, interactive experiences</li>
                <li>Turn complex ideas into simple, beautiful products</li>
              </ul>

              <h3>Our approach</h3>
              <p>
                We believe great digital products start with understanding the people who will 
                use them. Every project begins with listening — to your goals, your users, and 
                the problem you're solving. From there, we design, build, and launch with care 
                and attention to detail.
              </p>
            </div>

            <div className="about-stats">
              <div className="stat-card">
                <h3>6+</h3>
                <p>Years of Experience</p>
              </div>
              <div className="stat-card">
                <h3>20+</h3>
                <p>Projects Delivered</p>
              </div>
              <div className="stat-card">
                <h3>4</h3>
                <p>Active Builds</p>
              </div>
              <div className="stat-card">
                <h3>100%</h3>
                <p>Client Focused</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="about-cta">
        <div className="container">
          <h2>Let's build something together</h2>
          <p>Have a project in mind? We'd love to hear about it.</p>
          <Link to="/contact" className="cta-button">
            Start a Conversation
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;
